import { createFileRoute } from "@tanstack/react-router";

import DocumentsPage from "@/features/dashboard/pages/documents";

export const Route = createFileRoute("/(app)/dashboard/documents")({
  // `?q=` lets a search hit land on the document rather than on the whole shelf. There is no
  // per-document route, so this is the deep link.
  validateSearch: (search: Record<string, unknown>) => ({
    q: typeof search.q === "string" && search.q.trim() ? search.q : undefined,
  }),
  component: () => <DocumentsPage />,
});
